module.exports = ".sanitize-html {\n    margin: 0 0.2667rem;\n    line-height: 0.64rem;\n}"